export default function initStoreTabs() {
  const tabs = [...document.querySelectorAll('[data-store-tab]')];

  if (!tabs.length) {
    return;
  }

  const activateTab = (tab) => {
    const panelId = tab.getAttribute('aria-controls');

    tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    document.querySelectorAll('[data-store-panel]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      event.preventDefault();
      let nextIndex = index;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      activateTab(tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });
}
